/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_2_Item_Contact_DescInputs */

const en_privacy_section_2_item_contact_desc = /** @type {(inputs: Privacy_Section_2_Item_Contact_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`your name, email address, and message content when you reach out to us`)
};

const lv_privacy_section_2_item_contact_desc = /** @type {(inputs: Privacy_Section_2_Item_Contact_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jūsu vārds, e-pasta adrese un ziņas saturs, kad sazināties ar mums`)
};

/**
* | output |
* | --- |
* | "your name, email address, and message content when you reach out to us" |
*
* @param {Privacy_Section_2_Item_Contact_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_2_item_contact_desc = /** @type {((inputs?: Privacy_Section_2_Item_Contact_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_2_Item_Contact_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_2_item_contact_desc(inputs)
	return en_privacy_section_2_item_contact_desc(inputs)
});